module.exports = __webpack_public_path__ + "static/media/calender.f1ec4713.svg";